import { FETCH_PREVIEW_PAGES, FETCH_PREVIEW_DOMAIN_SUCCEEDED } from '../actions/ActionTypes';
const initialState = {
  previewDomain: '',
  previewPages: []
};
const previewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PREVIEW_DOMAIN_SUCCEEDED:
      return Object.assign({}, state, {
        previewDomain: action.previewDomain.previewDomain
      });
    case FETCH_PREVIEW_PAGES.SUCCEEDED:
      return Object.assign({}, state, {
        previewPages: action.payload
      });
    default:
      return state;
  }
};
export default previewReducer;